<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .experience-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;
    gap: utils.in_rem(8px);

    &.skeleton {
      @include mixins.skeleton(
        (
          background-color: colors.get(interfaceTransparentBlack_4),
          border-radius: utils.in_rem(8px),
        )
      );
    }

    .divider {
      width: 100%;
      height: 1px;
      background-color: rgba(28, 28, 28, 0.05);
      flex-shrink: 0;
    }

    .no-data-wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .no-data-text {
        @include colors.color(textGrey);

        h3 {
          @include mixins.h3();
          text-align: center;
        }

        span {
          @include mixins.body2();
          text-align: center;
        }
      }
    }
  }
</style>

<script>
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import NoData from "@sourcewhale/shared/svelte-design-system/components/atoms/NoData.svelte";
  import { candidateExperienceStore } from "../../stores";
  import ExperienceItem from "./ExperienceItem.svelte";

  const { meta } = candidateExperienceStore;

  $: skeleton = $meta.fetching || !$meta.firstFetchDone;
</script>

<div class="experience-container" class:skeleton>
  {#if !skeleton}
    {#if $candidateExperienceStore.length > 0}
      {#each $candidateExperienceStore as experience, index (experience.startedAt + experience.company + experience.role)}
        <ExperienceItem {experience} />
        {#if index < $candidateExperienceStore.length - 1}
          <div class="divider"></div>
        {/if}
      {/each}
    {:else}
      <div class="no-data-wrapper">
        <NoData>
          <div slot="icons" class="icons">
            <IconScale
              backgroundColor="interfaceSwGrey_10"
              color="interfaceSwGrey_20"
              class="fa-solid fa-briefcase"
              size="xl"
            />
          </div>
          <div slot="text" class="no-data-text">
            <h3>No experience available</h3>
            <span>This contact has no work experience</span>
          </div>
        </NoData>
      </div>
    {/if}
  {/if}
</div>
